import script from "./company-broker-association.vue?vue&type=script&setup=true&lang=js"
export * from "./company-broker-association.vue?vue&type=script&setup=true&lang=js"

import "./company-broker-association.vue?vue&type=style&index=0&id=19c259f4&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19c259f4"]])

export default __exports__